import { render, staticRenderFns } from "./RefundPostProcessCorrectionDialog.vue?vue&type=template&id=196e7f41&lang=pug&"
import script from "./RefundPostProcessCorrectionDialog.vue?vue&type=script&lang=ts&"
export * from "./RefundPostProcessCorrectionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports